/**
 * @module datetime/remoteDate
 * @since 2.0.0
 */

import { MINUTE_IN_MS } from '..';

/**
 * Get a remote date object according to an offset.
 * @param  {Number} offset The offset from UTC time in miliseconds.
 * @return {Date}
 *
 * @example getRemote(remoteOffset);
 */
export function remoteDate(offset) {
    const date = new Date();
    const localOffset = date.getTimezoneOffset();
    const localTime = date.getTime();

    const localOffsetMsec = localOffset * MINUTE_IN_MS;
    const remoteOffsetMsec = offset * MINUTE_IN_MS;
    const remoteTime = localTime + localOffsetMsec - remoteOffsetMsec;

    return new Date(remoteTime);
}
